<template>
  <v-combobox
    :outlined="outlined"
    v-bind="$attrs"
    @input="updateFieldValue(name, $event)"
    @change="$emit('change', $event)"
    @keyup="$emit('keyup', $event)"
    @paste="$emit('paste', $event)"
    :value="currentValue"
    :messages="[error]"
    :error="!!error"
    clearable
    hide-selected
  ></v-combobox>
</template>
<script>
import baseInput from "./baseInput";
export default {
  props: {
    outlined: {
      default: true,
      type: Boolean,
    },
  },
  mixins: [baseInput],
};
</script>
